module.exports = __webpack_public_path__ + "img/375.2d1f7cc1.jpg";